import React from 'react';

import { AppConstants } from '../../../constants/appConstants';

import ImgDesktopSrc from '../../../images/disputa-360/banner-disputa360-desktop.png';
import ImgMobileSrc from '../../../images/disputa-360/banner-disputa360-mobile.png';
import { Container, Img, Link } from './styles';

const Disputa360Banner = () => {
  return (
    <Container data-gtm-banner="disputa-360">
      <Link href={AppConstants.externalApps.newOffers} target="_blank" rel="noopener noreferrer">
        <Img className="desktop-img" src={ImgDesktopSrc} alt="Conheça a Disputa 360" />
        <Img className="mobile-img" src={ImgMobileSrc} alt="Conheça a Disputa 360" />
      </Link>
    </Container>
  );
};

export default Disputa360Banner;
